export const moveGraphToNewLocation = (updateGraphs, old_idx, new_idx) => {
  updateGraphs((graphs) => {
    const newGraphs = Object.assign([], graphs)
    const movedPlot = newGraphs[old_idx]
    newGraphs.splice(old_idx, 1)
    newGraphs.splice(new_idx, 0, movedPlot)
    return newGraphs
  })
}
